import React, { useEffect, useState } from "react";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { registerZipUser, zipVerifyOtpApi } from "../../http/http";
import { setUserZip } from "../../store/slices/userZipGameTokenSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import SmallLoader from "../../components/Loaders/SmallLoader";

const VerifyZipOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const msisdn = location?.state?.msisdn || "";
  const [otp, setOtp] = useState(["", "", "", ""]);

  useEffect(() => {
    if (!msisdn) {
      navigate("/register/zip-game");
    }
  }, [msisdn, navigate]);

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleNext = async () => {
    const finalOtp = otp.join("");
    if (finalOtp.length !== 4) return;

    try {
      setLoading(true);
      const response = await zipVerifyOtpApi(msisdn, finalOtp);
      console.log(response?.data?.result, 'response==');

      setLoading(false);

      if (response?.data?.result?.regiserStatus == 1) {
        // user is already registered
        toast.success(t("346"));
        dispatch(setUserZip(response?.data?.result));
        navigate("/zip-game-details");
      }
      else if (response?.data?.result?.regiserStatus == 2) {
        // new user registered successfully!
        toast.success(t("347"));
        dispatch(setUserZip(response?.data?.result));
        navigate("/zip-game-details");
      }
      else {
        toast.error(t("86"));
      }
    } catch (error) {
      setLoading(false);

      console.log(error, 'error--');
      if (error?.response?.data?.status == 0) {
        toast.error(t("88"));
      }
      else {
        toast.error(t("86"))
      }
    }
  };

  return (
    <>
      <Header />

      <div className={classes.container}>
        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>ZIP GAME</div>
          <h1 className={classes.heroTitle}>{t("188")}</h1>
          <p className={classes.heroText}>
            {t("189")}
          </p>
        </div>

        <ZipGameStepper currentStep={2} />

        <div className={classes.formCard}>
          <div className={classes.section}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("190")}</h2>
              <p className={classes.sectionText}>
                {t("191")} +241 {msisdn}
              </p>
            </div>

            <div className={classes.otpWrapper}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  className={classes.otpInput}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleOtpKeyDown(index, e)}
                />
              ))}
            </div>

            <div className={classes.actionRow}>

              <button type="button" className={classes.primaryBtn} onClick={handleNext}
                disabled={loading}
              >
                {loading ? <SmallLoader /> : t("192")}
              </button>
              <button
                type="button"
                className={classes.secondaryBtn}
                disabled={loading}
                onClick={() => navigate("/register/zip-game")}
              >
                {t("193")}
              </button>
            </div>

            {/* <button type="button" className={classes.linkBtn}>
              Resend OTP
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyZipOtp;